let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5f97m")).then(() => parcelRequire('lrQFd'));